// extracted by mini-css-extract-plugin
export var container = "syntax-diagram-module--container--79219";
export var root = "syntax-diagram-module--root--bc9a1";
export var toolbar = "syntax-diagram-module--toolbar--d0006";